module.exports = __webpack_public_path__ + "static/changing-the-face-of-science-image-3-800x533-45f46677b24544bda28871d7c464729a.jpg";